import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormControl, FormGroupDirective } from '@angular/forms';
import { SttTableService } from '../stt-table/stt-table-service';
import { SelectableRow, Table } from 'primeng/table';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
    selector: 'app-stt-overlay-table',
    templateUrl: './stt-overlay-table.component.html',
    styleUrls: ['./stt-overlay-table.component.scss']
})

export class SttOverlayTableComponent implements OnInit {

    @Input() endpoint: string;
    @Input() readonly = false;
    @Input() fields = { text: 'name', value: 'id' };

    @Output() changeEvent = new EventEmitter<any>();
    @Output() loadedData = new EventEmitter<any>();

    @ViewChild('op', { static: false }) op: OverlayPanel;

    public tableQuery: SttTableService;
    public formControl: UntypedFormControl;
    public selectedRow: any;

    private lastOpenEvent: MouseEvent;

    constructor(private parentF: FormGroupDirective) {
        this.tableQuery = new SttTableService();
        this.tableQuery.perPage = 5;
    }

    @Input() set controlName(value) {
        this.formControl = this.parentF.form.get(value) as UntypedFormControl;
    }

    ngOnInit(): void {

    }

    onRowSelect($event: SelectableRow): void {
        this.selectedRow = $event.data;
        this.changeEvent.emit(this.selectedRow);
        this.op.hide();
    }

    onOpenOverlay($event: MouseEvent) {
        this.lastOpenEvent = $event;
        this.op.toggle($event);
    }
}

